import React from "react";

export const PricePage = () => {
    return (
       <div>
        bang gia
       </div>
    )
}